import type { RouteRecordRaw } from 'vue-router'
import { propertiesRoutes } from '@modules/properties'
import { rentalDistributionsRoutes } from '@modules/rentalDistributions'
import { listingRequestsRoutes } from '@modules/listingRequests'
import { investorsRoutes } from '@modules/investors'
import { portfoliosRoutes } from '@modules/portfolios'
import { offeringsRoutes } from '@modules/offerings'
import { ordersRoutes } from '@modules/orders'
import { marketplaceRoutes } from '@modules/marketplace'
import { propertyOwnersRoutes } from '@modules/propertyOwners'
import { settingsRoutes } from '@modules/settings'
import { mastersRoutes } from '@modules/masters'
import { dashboardRoutes } from '@modules/dashboard'
import { helpRoutes } from '@modules/help'
import { adminsRoutes } from '@modules/admins'
import { notificationsRoutes } from '@modules/notifications'
import { complianceRoutes } from '@modules/compliance'
import { rolesRoutes } from '@modules/roles'
import { walletsRoutes } from '@modules/wallets'
import { treasuryRoutes } from '@modules/treasury'
import { vaspRoutes } from '@modules/vasp'

export const privateRoutes: RouteRecordRaw[] = [
  ...propertiesRoutes,
  ...rentalDistributionsRoutes,
  ...listingRequestsRoutes,
  ...investorsRoutes,
  ...portfoliosRoutes,
  ...offeringsRoutes,
  ...ordersRoutes,
  ...marketplaceRoutes,
  ...propertyOwnersRoutes,
  ...settingsRoutes,
  ...mastersRoutes,
  ...dashboardRoutes,
  ...helpRoutes,
  ...adminsRoutes,
  ...notificationsRoutes,
  ...complianceRoutes,
  ...rolesRoutes,
  ...walletsRoutes,
  ...treasuryRoutes,
  ...vaspRoutes,
]
